export default __webpack_public_path__ + "static/media/avatar02.311a0bee.svg";